import React from 'react';
function StatusSquare() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
			<rect width="100" height="100" className="status-circle" />
		</svg>
	);
}
export default StatusSquare;


/** WEBPACK FOOTER **
 ** ./src/modules/images/StatusSquare.js
 **/